import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getCookie } from './helpers/index';

var language = 'vn';

if(getCookie('language_landing')) {
	language = getCookie('language_landing');
}

i18n
	.use(LanguageDetector)
	.init({
		// we init with resources
		resources: {
			en: {
				translations: {
					"view_more": "View more",
					"related_posts":"Related Posts",
					"popular":"Popular",
					"by":"By",
					"hour_ago":"hour(s) ago",
					"day_ago":"day(s) ago",
					"back_page": "Back",
					"info_store": "Infomation",
					"address_store": "Address",
					"phone_store": "Phone number",
					"time_open_store": "Business hours",
					"related_product": "Related product",
					"most_popular": "Most popular",
					"stores": "Stores",
					"drink": "Drink",
					"link": "Link",
					"contact": "Contact",
					"not_found": "Page not found!",
					"news" : "News",
					"career": "Career",
					"products": "Products",
					"grocery": "Grocery"
				}
			},
			vn: {
				translations: {
					"view_more": "Xem thêm",
					"related_posts":"Bài liên quan",
					"popular":"Phổ biến",
					"by":"Bởi",
                    "hour_ago":"giờ trước",
                    "day_ago":"ngày trước",
					"back_page": "Quay lại",
					"info_store": "Thông tin cửa hàng",
					"address_store": "Địa chỉ",
					"phone_store": "Điện Thoại",
					"time_open_store": "Giờ mở cửa",
					"related_product": "Sản Phẩm Liên Quan",
					"most_popular": "Xem nhiều",
					"stores": "Cửa hàng",
					"drink": "Đồ uống",
					"link": "hợp tác",
					"contact": "Liên hệ",
					"not_found": "Nội dung bạn tìm kiếm không tồn tại!",
					"news" : "Tin Tức",
					"career": "Tuyển dụng",
					"products": "Tạp hóa",
					"grocery": "Tạp hóa"
				}
			}
		},
		lng: language,
		fallbackLng: 'vn',

		// have a common namespace used around the full app
		ns: ['translations'],
		defaultNS: 'translations',

		keySeparator: false, // we use content as keys

		interpolation: {
			escapeValue: false, // not needed for react!!
			formatSeparator: ','
		},

		react: {
			wait: true
		}
	});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.tsx